@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(-1_258_498_091)
public val Res.string.settings_edit_location: StringResource by lazy {
      StringResource("string:settings_edit_location", "settings_edit_location", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 280624, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 397860, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 257327, 50),
      ))
    }

@delegate:ResourceContentHash(2_035_269_952)
public val Res.string.settings_edit_payroll: StringResource by lazy {
      StringResource("string:settings_edit_payroll", "settings_edit_payroll", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 280679, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 397951, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 257378, 61),
      ))
    }

@delegate:ResourceContentHash(1_044_963_098)
public val Res.string.settings_edit_sales_targets: StringResource by lazy {
      StringResource("string:settings_edit_sales_targets", "settings_edit_sales_targets", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 280745, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 398077, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 257440, 67),
      ))
    }

@delegate:ResourceContentHash(1_493_238_744)
public val Res.string.settings_edit_staff_skills: StringResource by lazy {
      StringResource("string:settings_edit_staff_skills", "settings_edit_staff_skills", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 280821, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 398193, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 257508, 62),
      ))
    }

@delegate:ResourceContentHash(-145_036_793)
public val Res.string.settings_edit_weekly_skeleton: StringResource by lazy {
      StringResource("string:settings_edit_weekly_skeleton", "settings_edit_weekly_skeleton", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 280904, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 398300, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 257571, 65),
      ))
    }

@delegate:ResourceContentHash(1_443_926_545)
public val Res.string.settings_financials: StringResource by lazy {
      StringResource("string:settings_financials", "settings_financials", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 281058, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 398518, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 257709, 43),
      ))
    }

@delegate:ResourceContentHash(909_707_708)
public val Res.string.settings_financials_updated: StringResource by lazy {
      StringResource("string:settings_financials_updated", "settings_financials_updated", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 280974, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 398398, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 257637, 71),
      ))
    }

@delegate:ResourceContentHash(369_612_694)
public val Res.string.settings_find_coordinates: StringResource by lazy {
      StringResource("string:settings_find_coordinates", "settings_find_coordinates", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 281098, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 398566, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 257753, 57),
      ))
    }

@delegate:ResourceContentHash(725_165_726)
public val Res.string.settings_first_day: StringResource by lazy {
      StringResource("string:settings_first_day", "settings_first_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 281223, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 398723, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 257870, 38),
      ))
    }

@delegate:ResourceContentHash(-1_389_312_490)
public val Res.string.settings_first_day_of_week: StringResource by lazy {
      StringResource("string:settings_first_day_of_week", "settings_first_day_of_week", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 281156, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 398644, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 257811, 58),
      ))
    }

@delegate:ResourceContentHash(-720_432_034)
public val Res.string.settings_fixed_revenue: StringResource by lazy {
      StringResource("string:settings_fixed_revenue", "settings_fixed_revenue", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 281474, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 399094, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 258081, 66),
      ))
    }

@delegate:ResourceContentHash(2_064_790_703)
public val Res.string.settings_fixed_revenue_hint: StringResource by lazy {
      StringResource("string:settings_fixed_revenue_hint", "settings_fixed_revenue_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 281282, 191),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 398794, 299),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 257909, 171),
      ))
    }

@delegate:ResourceContentHash(20_924_327)
public val Res.string.settings_footer: StringResource by lazy {
      StringResource("string:settings_footer", "settings_footer", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 282120, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 400092, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 258651, 59),
      ))
    }

@delegate:ResourceContentHash(1_881_990_526)
public val Res.string.settings_footer_hint: StringResource by lazy {
      StringResource("string:settings_footer_hint", "settings_footer_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 281553, 268),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 399209, 468),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 258148, 216),
      ))
    }

@delegate:ResourceContentHash(288_740_100)
public val Res.string.settings_footer_off: StringResource by lazy {
      StringResource("string:settings_footer_off", "settings_footer_off", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 281822, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 399678, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 258365, 35),
      ))
    }

@delegate:ResourceContentHash(-878_735_554)
public val Res.string.settings_footer_on: StringResource by lazy {
      StringResource("string:settings_footer_on", "settings_footer_on", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 281858, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 399730, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 258401, 34),
      ))
    }

@delegate:ResourceContentHash(-1_906_334_676)
public val Res.string.settings_footer_paid_only: StringResource by lazy {
      StringResource("string:settings_footer_paid_only", "settings_footer_paid_only", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 281897, 89),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 399781, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 258436, 85),
      ))
    }

@delegate:ResourceContentHash(1_862_544_367)
public val Res.string.settings_footer_switch: StringResource by lazy {
      StringResource("string:settings_footer_switch", "settings_footer_switch", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 281987, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 399915, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 258522, 78),
      ))
    }

@delegate:ResourceContentHash(231_436_347)
public val Res.string.settings_footer_title: StringResource by lazy {
      StringResource("string:settings_footer_title", "settings_footer_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 282070, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 400034, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 258601, 49),
      ))
    }

@delegate:ResourceContentHash(1_215_133_858)
public val Res.string.settings_force_majeure_limit: StringResource by lazy {
      StringResource("string:settings_force_majeure_limit", "settings_force_majeure_limit", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 282184, 104),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 400176, 144),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 258711, 76),
      ))
    }

@delegate:ResourceContentHash(-458_244_779)
public val Res.string.settings_general_info: StringResource by lazy {
      StringResource("string:settings_general_info", "settings_general_info", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 282289, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 400321, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 258788, 57),
      ))
    }

@delegate:ResourceContentHash(-190_925_232)
public val Res.string.settings_general_settings: StringResource by lazy {
      StringResource("string:settings_general_settings", "settings_general_settings", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 282343, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 400403, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 258846, 57),
      ))
    }

@delegate:ResourceContentHash(1_860_854_609)
public val Res.string.settings_geocode_failed: StringResource by lazy {
      StringResource("string:settings_geocode_failed", "settings_geocode_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 282401, 151),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 400493, 211),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 258904, 151),
      ))
    }

@delegate:ResourceContentHash(607_967_742)
public val Res.string.settings_geofence: StringResource by lazy {
      StringResource("string:settings_geofence", "settings_geofence", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 283421, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 401989, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 259844, 49),
      ))
    }

@delegate:ResourceContentHash(1_869_537_737)
public val Res.string.settings_geofence_block: StringResource by lazy {
      StringResource("string:settings_geofence_block", "settings_geofence_block", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 282730, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 400994, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 259225, 39),
      ))
    }

@delegate:ResourceContentHash(1_918_730_876)
public val Res.string.settings_geofence_block_hint: StringResource by lazy {
      StringResource("string:settings_geofence_block_hint", "settings_geofence_block_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 282553, 176),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 400705, 288),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 259056, 168),
      ))
    }

@delegate:ResourceContentHash(-780_410_976)
public val Res.string.settings_geofence_check: StringResource by lazy {
      StringResource("string:settings_geofence_check", "settings_geofence_check", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 282770, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 401050, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 259265, 51),
      ))
    }

@delegate:ResourceContentHash(2_112_454_597)
public val Res.string.settings_geofence_meters: StringResource by lazy {
      StringResource("string:settings_geofence_meters", "settings_geofence_meters", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 282834, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 401150, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 259317, 40),
      ))
    }

@delegate:ResourceContentHash(-1_545_999_066)
public val Res.string.settings_geofence_needs_location: StringResource by lazy {
      StringResource("string:settings_geofence_needs_location", "settings_geofence_needs_location", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 282875, 128),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 401195, 204),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 259358, 128),
      ))
    }

@delegate:ResourceContentHash(713_652_361)
public val Res.string.settings_geofence_off: StringResource by lazy {
      StringResource("string:settings_geofence_off", "settings_geofence_off", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 283127, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 401563, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 259586, 33),
      ))
    }

@delegate:ResourceContentHash(-1_973_240_618)
public val Res.string.settings_geofence_off_hint: StringResource by lazy {
      StringResource("string:settings_geofence_off_hint", "settings_geofence_off_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 283004, 122),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 401400, 162),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 259487, 98),
      ))
    }

@delegate:ResourceContentHash(1_046_348_354)
public val Res.string.settings_geofence_radius: StringResource by lazy {
      StringResource("string:settings_geofence_radius", "settings_geofence_radius", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 283173, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 401617, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 259620, 40),
      ))
    }

@delegate:ResourceContentHash(1_213_415_207)
public val Res.string.settings_geofence_warn: StringResource by lazy {
      StringResource("string:settings_geofence_warn", "settings_geofence_warn", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 283378, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 401926, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 259805, 38),
      ))
    }

@delegate:ResourceContentHash(936_102_883)
public val Res.string.settings_geofence_warn_hint: StringResource by lazy {
      StringResource("string:settings_geofence_warn_hint", "settings_geofence_warn_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 283218, 159),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 401666, 259),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 259661, 143),
      ))
    }

@delegate:ResourceContentHash(-1_488_162_937)
public val Res.string.settings_geoplace: StringResource by lazy {
      StringResource("string:settings_geoplace", "settings_geoplace", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 283939, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 402595, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 260222, 45),
      ))
    }

@delegate:ResourceContentHash(431_121_958)
public val Res.string.settings_geoplace_help: StringResource by lazy {
      StringResource("string:settings_geoplace_help", "settings_geoplace_help", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 283495, 238),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 402103, 274),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 259894, 166),
      ))
    }

@delegate:ResourceContentHash(1_833_153_698)
public val Res.string.settings_geoplace_hint: StringResource by lazy {
      StringResource("string:settings_geoplace_hint", "settings_geoplace_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 283734, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 402378, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 260061, 58),
      ))
    }

@delegate:ResourceContentHash(996_459_917)
public val Res.string.settings_geoplace_invalid: StringResource by lazy {
      StringResource("string:settings_geoplace_invalid", "settings_geoplace_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 283805, 133),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 402457, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 260120, 101),
      ))
    }

@delegate:ResourceContentHash(836_566_677)
public val Res.string.settings_help_availability_slots: StringResource by lazy {
      StringResource("string:settings_help_availability_slots", "settings_help_availability_slots", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 283989, 376),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 402653, 556),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 260268, 360),
      ))
    }

@delegate:ResourceContentHash(968_156_829)
public val Res.string.settings_help_breaks: StringResource by lazy {
      StringResource("string:settings_help_breaks", "settings_help_breaks", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 284366, 704),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 403210, 1104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 260629, 688),
      ))
    }

@delegate:ResourceContentHash(-428_594_813)
public val Res.string.settings_help_clock_review: StringResource by lazy {
      StringResource("string:settings_help_clock_review", "settings_help_clock_review", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 285071, 342),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 404315, 542),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 261318, 258),
      ))
    }

@delegate:ResourceContentHash(-1_262_433_074)
public val Res.string.settings_help_financials: StringResource by lazy {
      StringResource("string:settings_help_financials", "settings_help_financials", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 285414, 1640),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 404858, 2724),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 261577, 1480),
      ))
    }

@delegate:ResourceContentHash(1_729_561_605)
public val Res.string.settings_help_general: StringResource by lazy {
      StringResource("string:settings_help_general", "settings_help_general", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 287055, 857),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 407583, 1353),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 263058, 753),
      ))
    }

@delegate:ResourceContentHash(1_838_990_317)
public val Res.string.settings_help_geofence: StringResource by lazy {
      StringResource("string:settings_help_geofence", "settings_help_geofence", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 287913, 526),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 408937, 958),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 263812, 470),
      ))
    }

@delegate:ResourceContentHash(-1_340_948_322)
public val Res.string.settings_help_labour_budget: StringResource by lazy {
      StringResource("string:settings_help_labour_budget", "settings_help_labour_budget", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 288440, 719),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 409896, 1255),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 264283, 687),
      ))
    }

@delegate:ResourceContentHash(-1_606_638_280)
public val Res.string.settings_help_payroll: StringResource by lazy {
      StringResource("string:settings_help_payroll", "settings_help_payroll", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 289160, 1205),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 411152, 2089),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 264971, 1085),
      ))
    }

@delegate:ResourceContentHash(-1_067_969_595)
public val Res.string.settings_help_request_types: StringResource by lazy {
      StringResource("string:settings_help_request_types", "settings_help_request_types", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 290366, 259),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 413242, 383),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 266057, 203),
      ))
    }

@delegate:ResourceContentHash(1_434_863_843)
public val Res.string.settings_help_requests: StringResource by lazy {
      StringResource("string:settings_help_requests", "settings_help_requests", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 290626, 214),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 413626, 346),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 266261, 198),
      ))
    }

@delegate:ResourceContentHash(356_538_400)
public val Res.string.settings_help_roster_blueprint: StringResource by lazy {
      StringResource("string:settings_help_roster_blueprint", "settings_help_roster_blueprint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 290841, 426),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 413973, 678),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 266460, 418),
      ))
    }

@delegate:ResourceContentHash(532_062_327)
public val Res.string.settings_help_sales_targets: StringResource by lazy {
      StringResource("string:settings_help_sales_targets", "settings_help_sales_targets", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 291268, 343),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 414652, 643),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 266879, 359),
      ))
    }

@delegate:ResourceContentHash(-825_825_398)
public val Res.string.settings_help_staff_skills: StringResource by lazy {
      StringResource("string:settings_help_staff_skills", "settings_help_staff_skills", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 291612, 942),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 415296, 1338),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 267239, 670),
      ))
    }

@delegate:ResourceContentHash(1_059_449_902)
public val Res.string.settings_help_sunday: StringResource by lazy {
      StringResource("string:settings_help_sunday", "settings_help_sunday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 292555, 604),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 416635, 1140),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 267910, 600),
      ))
    }

@delegate:ResourceContentHash(-1_272_902_323)
public val Res.string.settings_labour_budget_enable: StringResource by lazy {
      StringResource("string:settings_labour_budget_enable", "settings_labour_budget_enable", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 293160, 85),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 417776, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 268511, 77),
      ))
    }

@delegate:ResourceContentHash(1_022_227_287)
public val Res.string.settings_labour_budget_hint: StringResource by lazy {
      StringResource("string:settings_labour_budget_hint", "settings_labour_budget_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 293246, 239),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 417906, 399),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 268589, 199),
      ))
    }

@delegate:ResourceContentHash(1_141_786_329)
public val Res.string.settings_labour_budget_invalid: StringResource by lazy {
      StringResource("string:settings_labour_budget_invalid", "settings_labour_budget_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 293486, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 418306, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 268789, 74),
      ))
    }

@delegate:ResourceContentHash(-819_366_377)
public val Res.string.settings_labour_budget_monthly: StringResource by lazy {
      StringResource("string:settings_labour_budget_monthly", "settings_labour_budget_monthly", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 293565, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 418409, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 268864, 58),
      ))
    }

@delegate:ResourceContentHash(715_231_284)
public val Res.string.settings_labour_budget_off: StringResource by lazy {
      StringResource("string:settings_labour_budget_off", "settings_labour_budget_off", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 293632, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 418488, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 268923, 38),
      ))
    }

@delegate:ResourceContentHash(1_710_246_073)
public val Res.string.settings_labour_budget_saved: StringResource by lazy {
      StringResource("string:settings_labour_budget_saved", "settings_labour_budget_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 293683, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 418547, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 268962, 64),
      ))
    }

@delegate:ResourceContentHash(-878_889_265)
public val Res.string.settings_labour_budget_weekly: StringResource by lazy {
      StringResource("string:settings_labour_budget_weekly", "settings_labour_budget_weekly", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 293911, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 418867, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 269134, 57),
      ))
    }

@delegate:ResourceContentHash(-83_689_853)
public val Res.string.settings_labour_budget_weekly_hint: StringResource by lazy {
      StringResource("string:settings_labour_budget_weekly_hint", "settings_labour_budget_weekly_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 293756, 154),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 418656, 210),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 269027, 106),
      ))
    }

@delegate:ResourceContentHash(-1_447_358_901)
public val Res.string.settings_labour_target: StringResource by lazy {
      StringResource("string:settings_labour_target", "settings_labour_target", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 294864, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 420268, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 270015, 66),
      ))
    }

@delegate:ResourceContentHash(-475_717_180)
public val Res.string.settings_labour_target_converted: StringResource by lazy {
      StringResource("string:settings_labour_target_converted", "settings_labour_target_converted", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 293973, 196),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 418945, 284),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 269192, 184),
      ))
    }

@delegate:ResourceContentHash(876_248_937)
public val Res.string.settings_labour_target_default: StringResource by lazy {
      StringResource("string:settings_labour_target_default", "settings_labour_target_default", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 294170, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 419230, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 269377, 58),
      ))
    }

@delegate:ResourceContentHash(322_205_957)
public val Res.string.settings_labour_target_hint: StringResource by lazy {
      StringResource("string:settings_labour_target_hint", "settings_labour_target_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 294233, 395),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 419297, 643),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 269436, 339),
      ))
    }

@delegate:ResourceContentHash(1_943_672_628)
public val Res.string.settings_labour_target_invalid: StringResource by lazy {
      StringResource("string:settings_labour_target_invalid", "settings_labour_target_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 294629, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 419941, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 269776, 62),
      ))
    }

@delegate:ResourceContentHash(1_309_954_211)
public val Res.string.settings_labour_target_sales_equivalent: StringResource by lazy {
      StringResource("string:settings_labour_target_sales_equivalent", "settings_labour_target_sales_equivalent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 294684, 179),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 420004, 263),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 269839, 175),
      ))
    }

@delegate:ResourceContentHash(717_074_590)
public val Res.string.settings_lead_mark_role: StringResource by lazy {
      StringResource("string:settings_lead_mark_role", "settings_lead_mark_role", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 294943, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 420391, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 270082, 43),
      ))
    }

@delegate:ResourceContentHash(-882_736_059)
public val Res.string.settings_lead_mark_skill: StringResource by lazy {
      StringResource("string:settings_lead_mark_skill", "settings_lead_mark_skill", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 294991, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 420439, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 270126, 40),
      ))
    }

@delegate:ResourceContentHash(761_618_665)
public val Res.string.settings_lead_marks: StringResource by lazy {
      StringResource("string:settings_lead_marks", "settings_lead_marks", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 295409, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 421037, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 270384, 43),
      ))
    }

@delegate:ResourceContentHash(-2_086_396_380)
public val Res.string.settings_lead_marks_hint: StringResource by lazy {
      StringResource("string:settings_lead_marks_hint", "settings_lead_marks_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 295044, 364),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 420492, 544),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 270167, 216),
      ))
    }

@delegate:ResourceContentHash(1_915_331_225)
public val Res.string.settings_limit_blood_field: StringResource by lazy {
      StringResource("string:settings_limit_blood_field", "settings_limit_blood_field", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 295461, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 421093, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 270428, 50),
      ))
    }

@delegate:ResourceContentHash(-14_924_160)
public val Res.string.settings_limit_explain_blood: StringResource by lazy {
      StringResource("string:settings_limit_explain_blood", "settings_limit_explain_blood", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 295520, 260),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 421160, 420),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 270479, 256),
      ))
    }

@delegate:ResourceContentHash(756_833_818)
public val Res.string.settings_limit_explain_care: StringResource by lazy {
      StringResource("string:settings_limit_explain_care", "settings_limit_explain_care", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 296238, 479),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 422366, 715),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 271173, 459),
      ))
    }

@delegate:ResourceContentHash(1_946_254_368)
public val Res.string.settings_limit_explain_carer: StringResource by lazy {
      StringResource("string:settings_limit_explain_carer", "settings_limit_explain_carer", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 295781, 456),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 421581, 784),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 270736, 436),
      ))
    }

@delegate:ResourceContentHash(-1_083_490_276)
public val Res.string.settings_limit_explain_childcare: StringResource by lazy {
      StringResource("string:settings_limit_explain_childcare", "settings_limit_explain_childcare", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 296718, 408),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 423082, 672),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 271633, 408),
      ))
    }

@delegate:ResourceContentHash(-2_009_888_293)
public val Res.string.settings_limit_explain_force_majeure: StringResource by lazy {
      StringResource("string:settings_limit_explain_force_majeure", "settings_limit_explain_force_majeure", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 297127, 464),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 423755, 768),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 272042, 460),
      ))
    }

@delegate:ResourceContentHash(-694_408_898)
public val Res.string.settings_limit_year_field: StringResource by lazy {
      StringResource("string:settings_limit_year_field", "settings_limit_year_field", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 297592, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 424524, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 272503, 49),
      ))
    }

@delegate:ResourceContentHash(448_240_920)
public val Res.string.settings_limits_restore: StringResource by lazy {
      StringResource("string:settings_limits_restore", "settings_limits_restore", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 297714, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 424678, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 272621, 55),
      ))
    }

@delegate:ResourceContentHash(1_498_997_020)
public val Res.string.settings_limits_restore_for: StringResource by lazy {
      StringResource("string:settings_limits_restore_for", "settings_limits_restore_for", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 297642, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 424590, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 272553, 67),
      ))
    }

@delegate:ResourceContentHash(897_248_669)
public val Res.string.settings_location: StringResource by lazy {
      StringResource("string:settings_location", "settings_location", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 297844, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 424844, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 272735, 37),
      ))
    }

@delegate:ResourceContentHash(-818_708_678)
public val Res.string.settings_location_updated: StringResource by lazy {
      StringResource("string:settings_location_updated", "settings_location_updated", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 297774, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 424754, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 272677, 57),
      ))
    }

@delegate:ResourceContentHash(-511_976_310)
public val Res.string.settings_map: StringResource by lazy {
      StringResource("string:settings_map", "settings_map", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 298240, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 425428, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 273071, 60),
      ))
    }

@delegate:ResourceContentHash(-662_840_055)
public val Res.string.settings_map_hint: StringResource by lazy {
      StringResource("string:settings_map_hint", "settings_map_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 297886, 141),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 424902, 225),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 272773, 105),
      ))
    }

@delegate:ResourceContentHash(1_965_867_046)
public val Res.string.settings_map_no_pin: StringResource by lazy {
      StringResource("string:settings_map_no_pin", "settings_map_no_pin", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 298028, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 425128, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 272879, 43),
      ))
    }

@delegate:ResourceContentHash(109_280_677)
public val Res.string.settings_map_pin: StringResource by lazy {
      StringResource("string:settings_map_pin", "settings_map_pin", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 298104, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 425200, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 272923, 64),
      ))
    }

@delegate:ResourceContentHash(-743_894_162)
public val Res.string.settings_map_zoom_in: StringResource by lazy {
      StringResource("string:settings_map_zoom_in", "settings_map_zoom_in", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 298161, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 425321, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 272988, 40),
      ))
    }

@delegate:ResourceContentHash(489_734_109)
public val Res.string.settings_map_zoom_out: StringResource by lazy {
      StringResource("string:settings_map_zoom_out", "settings_map_zoom_out", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 298202, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 425374, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 273029, 41),
      ))
    }

@delegate:ResourceContentHash(-1_536_365_988)
public val Res.string.settings_market: StringResource by lazy {
      StringResource("string:settings_market", "settings_market", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 298297, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 425525, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 273132, 39),
      ))
    }

@delegate:ResourceContentHash(-1_682_478_265)
public val Res.string.settings_more: StringResource by lazy {
      StringResource("string:settings_more", "settings_more", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 298337, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 425585, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 273172, 29),
      ))
    }

@delegate:ResourceContentHash(1_524_709_883)
public val Res.string.settings_name: StringResource by lazy {
      StringResource("string:settings_name", "settings_name", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 298433, 29),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 425693, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 273252, 29),
      ))
    }

@delegate:ResourceContentHash(-451_629_446)
public val Res.string.settings_name_updated: StringResource by lazy {
      StringResource("string:settings_name_updated", "settings_name_updated", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 298371, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 425623, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 273202, 49),
      ))
    }

@delegate:ResourceContentHash(-253_244_283)
public val Res.string.settings_new_slot_title: StringResource by lazy {
      StringResource("string:settings_new_slot_title", "settings_new_slot_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 298463, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 425731, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 273282, 59),
      ))
    }

@delegate:ResourceContentHash(-1_598_450_391)
public val Res.string.settings_night_end: StringResource by lazy {
      StringResource("string:settings_night_end", "settings_night_end", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 298531, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 425803, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 273342, 50),
      ))
    }

@delegate:ResourceContentHash(216_111_045)
public val Res.string.settings_night_hint: StringResource by lazy {
      StringResource("string:settings_night_hint", "settings_night_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 298594, 139),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 425894, 247),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 273393, 155),
      ))
    }

@delegate:ResourceContentHash(-478_293_580)
public val Res.string.settings_night_period: StringResource by lazy {
      StringResource("string:settings_night_period", "settings_night_period", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 298734, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 426142, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 273549, 45),
      ))
    }

@delegate:ResourceContentHash(1_015_685_495)
public val Res.string.settings_night_start: StringResource by lazy {
      StringResource("string:settings_night_start", "settings_night_start", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 298780, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 426200, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 273595, 56),
      ))
    }

@delegate:ResourceContentHash(-896_185_940)
public val Res.string.settings_no_show: StringResource by lazy {
      StringResource("string:settings_no_show", "settings_no_show", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 299204, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 426832, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 273975, 44),
      ))
    }

@delegate:ResourceContentHash(-1_805_097_870)
public val Res.string.settings_no_show_after: StringResource by lazy {
      StringResource("string:settings_no_show_after", "settings_no_show_after", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 298849, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 426297, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 273652, 58),
      ))
    }

@delegate:ResourceContentHash(-1_338_500_085)
public val Res.string.settings_no_show_desc: StringResource by lazy {
      StringResource("string:settings_no_show_desc", "settings_no_show_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 298912, 197),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 426400, 317),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 273711, 185),
      ))
    }

@delegate:ResourceContentHash(-1_618_933_945)
public val Res.string.settings_no_show_minutes: StringResource by lazy {
      StringResource("string:settings_no_show_minutes", "settings_no_show_minutes", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 299110, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 426718, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 273897, 44),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString35Resources(map: MutableMap<String, StringResource>) {
  map.put("settings_edit_location", Res.string.settings_edit_location)
  map.put("settings_edit_payroll", Res.string.settings_edit_payroll)
  map.put("settings_edit_sales_targets", Res.string.settings_edit_sales_targets)
  map.put("settings_edit_staff_skills", Res.string.settings_edit_staff_skills)
  map.put("settings_edit_weekly_skeleton", Res.string.settings_edit_weekly_skeleton)
  map.put("settings_financials", Res.string.settings_financials)
  map.put("settings_financials_updated", Res.string.settings_financials_updated)
  map.put("settings_find_coordinates", Res.string.settings_find_coordinates)
  map.put("settings_first_day", Res.string.settings_first_day)
  map.put("settings_first_day_of_week", Res.string.settings_first_day_of_week)
  map.put("settings_fixed_revenue", Res.string.settings_fixed_revenue)
  map.put("settings_fixed_revenue_hint", Res.string.settings_fixed_revenue_hint)
  map.put("settings_footer", Res.string.settings_footer)
  map.put("settings_footer_hint", Res.string.settings_footer_hint)
  map.put("settings_footer_off", Res.string.settings_footer_off)
  map.put("settings_footer_on", Res.string.settings_footer_on)
  map.put("settings_footer_paid_only", Res.string.settings_footer_paid_only)
  map.put("settings_footer_switch", Res.string.settings_footer_switch)
  map.put("settings_footer_title", Res.string.settings_footer_title)
  map.put("settings_force_majeure_limit", Res.string.settings_force_majeure_limit)
  map.put("settings_general_info", Res.string.settings_general_info)
  map.put("settings_general_settings", Res.string.settings_general_settings)
  map.put("settings_geocode_failed", Res.string.settings_geocode_failed)
  map.put("settings_geofence", Res.string.settings_geofence)
  map.put("settings_geofence_block", Res.string.settings_geofence_block)
  map.put("settings_geofence_block_hint", Res.string.settings_geofence_block_hint)
  map.put("settings_geofence_check", Res.string.settings_geofence_check)
  map.put("settings_geofence_meters", Res.string.settings_geofence_meters)
  map.put("settings_geofence_needs_location", Res.string.settings_geofence_needs_location)
  map.put("settings_geofence_off", Res.string.settings_geofence_off)
  map.put("settings_geofence_off_hint", Res.string.settings_geofence_off_hint)
  map.put("settings_geofence_radius", Res.string.settings_geofence_radius)
  map.put("settings_geofence_warn", Res.string.settings_geofence_warn)
  map.put("settings_geofence_warn_hint", Res.string.settings_geofence_warn_hint)
  map.put("settings_geoplace", Res.string.settings_geoplace)
  map.put("settings_geoplace_help", Res.string.settings_geoplace_help)
  map.put("settings_geoplace_hint", Res.string.settings_geoplace_hint)
  map.put("settings_geoplace_invalid", Res.string.settings_geoplace_invalid)
  map.put("settings_help_availability_slots", Res.string.settings_help_availability_slots)
  map.put("settings_help_breaks", Res.string.settings_help_breaks)
  map.put("settings_help_clock_review", Res.string.settings_help_clock_review)
  map.put("settings_help_financials", Res.string.settings_help_financials)
  map.put("settings_help_general", Res.string.settings_help_general)
  map.put("settings_help_geofence", Res.string.settings_help_geofence)
  map.put("settings_help_labour_budget", Res.string.settings_help_labour_budget)
  map.put("settings_help_payroll", Res.string.settings_help_payroll)
  map.put("settings_help_request_types", Res.string.settings_help_request_types)
  map.put("settings_help_requests", Res.string.settings_help_requests)
  map.put("settings_help_roster_blueprint", Res.string.settings_help_roster_blueprint)
  map.put("settings_help_sales_targets", Res.string.settings_help_sales_targets)
  map.put("settings_help_staff_skills", Res.string.settings_help_staff_skills)
  map.put("settings_help_sunday", Res.string.settings_help_sunday)
  map.put("settings_labour_budget_enable", Res.string.settings_labour_budget_enable)
  map.put("settings_labour_budget_hint", Res.string.settings_labour_budget_hint)
  map.put("settings_labour_budget_invalid", Res.string.settings_labour_budget_invalid)
  map.put("settings_labour_budget_monthly", Res.string.settings_labour_budget_monthly)
  map.put("settings_labour_budget_off", Res.string.settings_labour_budget_off)
  map.put("settings_labour_budget_saved", Res.string.settings_labour_budget_saved)
  map.put("settings_labour_budget_weekly", Res.string.settings_labour_budget_weekly)
  map.put("settings_labour_budget_weekly_hint", Res.string.settings_labour_budget_weekly_hint)
  map.put("settings_labour_target", Res.string.settings_labour_target)
  map.put("settings_labour_target_converted", Res.string.settings_labour_target_converted)
  map.put("settings_labour_target_default", Res.string.settings_labour_target_default)
  map.put("settings_labour_target_hint", Res.string.settings_labour_target_hint)
  map.put("settings_labour_target_invalid", Res.string.settings_labour_target_invalid)
  map.put("settings_labour_target_sales_equivalent", Res.string.settings_labour_target_sales_equivalent)
  map.put("settings_lead_mark_role", Res.string.settings_lead_mark_role)
  map.put("settings_lead_mark_skill", Res.string.settings_lead_mark_skill)
  map.put("settings_lead_marks", Res.string.settings_lead_marks)
  map.put("settings_lead_marks_hint", Res.string.settings_lead_marks_hint)
  map.put("settings_limit_blood_field", Res.string.settings_limit_blood_field)
  map.put("settings_limit_explain_blood", Res.string.settings_limit_explain_blood)
  map.put("settings_limit_explain_care", Res.string.settings_limit_explain_care)
  map.put("settings_limit_explain_carer", Res.string.settings_limit_explain_carer)
  map.put("settings_limit_explain_childcare", Res.string.settings_limit_explain_childcare)
  map.put("settings_limit_explain_force_majeure", Res.string.settings_limit_explain_force_majeure)
  map.put("settings_limit_year_field", Res.string.settings_limit_year_field)
  map.put("settings_limits_restore", Res.string.settings_limits_restore)
  map.put("settings_limits_restore_for", Res.string.settings_limits_restore_for)
  map.put("settings_location", Res.string.settings_location)
  map.put("settings_location_updated", Res.string.settings_location_updated)
  map.put("settings_map", Res.string.settings_map)
  map.put("settings_map_hint", Res.string.settings_map_hint)
  map.put("settings_map_no_pin", Res.string.settings_map_no_pin)
  map.put("settings_map_pin", Res.string.settings_map_pin)
  map.put("settings_map_zoom_in", Res.string.settings_map_zoom_in)
  map.put("settings_map_zoom_out", Res.string.settings_map_zoom_out)
  map.put("settings_market", Res.string.settings_market)
  map.put("settings_more", Res.string.settings_more)
  map.put("settings_name", Res.string.settings_name)
  map.put("settings_name_updated", Res.string.settings_name_updated)
  map.put("settings_new_slot_title", Res.string.settings_new_slot_title)
  map.put("settings_night_end", Res.string.settings_night_end)
  map.put("settings_night_hint", Res.string.settings_night_hint)
  map.put("settings_night_period", Res.string.settings_night_period)
  map.put("settings_night_start", Res.string.settings_night_start)
  map.put("settings_no_show", Res.string.settings_no_show)
  map.put("settings_no_show_after", Res.string.settings_no_show_after)
  map.put("settings_no_show_desc", Res.string.settings_no_show_desc)
  map.put("settings_no_show_minutes", Res.string.settings_no_show_minutes)
}
